import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProvedorIdioma, useIdioma } from './i18n/index.tsx';
import { ProvedorSessao, useSessao } from './sessao.tsx';
import { Login } from './paginas/Login.tsx';
import { paginaPublica } from './paginas/Senha.tsx';
import { MinhaConta } from './paginas/MinhaConta.tsx';
import { PaginaInicial } from './paginas/Inicio.tsx';
import { EstadoCarregando, Shell } from './layout/Shell.tsx';
import { TelaDeModuloMontada } from './modules/montar.tsx';
import { TELAS } from './modules/registro.ts';

const qc = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

function Roteador() {
  const { estado } = useSessao();
  const { t } = useIdioma();
  const { pathname } = useLocation();

  // convite e recuperacao de senha valem com ou sem sessao: o link do e-mail
  // pode abrir num navegador ja logado com outra conta
  const publica = paginaPublica(pathname);
  if (publica !== null) return publica;

  if (estado.fase === 'carregando') {
    return <EstadoCarregando texto={t('estado.carregando')} />;
  }
  if (estado.fase === 'fora') {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route element={<Shell />}>
        {/* O Inicio pode ser a tela de um modulo (rota "/"), por isso ela
            sai do map abaixo e entra por aqui, com o painel de reserva. */}
        <Route path="/" element={<PaginaInicial />} />
        <Route path="/conta" element={<MinhaConta />} />
        {/* Telas entregues pelos modulos, por descoberta. Tem precedencia
            sobre o placeholder: um modulo que entregou a tela nao deve
            continuar mostrando "em construcao". */}
        {TELAS.filter((tela) => tela.rota !== '/').map((tela) => (
          <Route key={tela.slug} path={tela.rota}
            element={<TelaDeModuloMontada tela={tela} />} />
        ))}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <QueryClientProvider client={qc}>
      <ProvedorIdioma>
        <ProvedorSessao>
          <BrowserRouter><Roteador /></BrowserRouter>
        </ProvedorSessao>
      </ProvedorIdioma>
    </QueryClientProvider>
  );
}
